import TextField from "@/components/form/inputs/TextField.vue"
import TextArea from "@/components/form/inputs/TextArea.vue"
import SelectField from "@/components/form/inputs/SelectField.vue"
import RadioButton from "@/components/form/inputs/RadioButton.vue"
import CheckBox from "@/components/form/inputs/CheckBox.vue"
import DatePicker from "@/components/form/inputs/DatePicker.vue"
import AddressInput from "@/components/form/inputs/AddressInput.vue"
import FlinksiFrame from "@/components/form/inputs/FlinksiFrame.vue"
import SmsVerification from "@/components/form/inputs/SmsVerification.vue"
// TODO -- add this slider input
// import Slider from "@/components/form/inputs/Slider.vue"

const COMPONENTS_PER_TYPE = {
    text: TextField,
    textarea: TextArea,
    select: SelectField,
    radio: RadioButton,
    checkbox: CheckBox,
    date: DatePicker,
    fulladdress: AddressInput,
    flinks: FlinksiFrame,
    smsverification: SmsVerification,
    // slider: Slider,
}

export function getComponent(type) {
    return COMPONENTS_PER_TYPE[type] ?? TextField;
}

export function getComponents() {
    return Object.values(COMPONENTS_PER_TYPE);
}
